<template>
  <div style="height: 100%">
    <div class="mb-3">
      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        dense
        outlined
        hide-details
        placeholder="รหัส - ชื่อพนักงาน"
        @input="handleSearch"
      ></v-text-field>
    </div>
    <div class="px-4 pb-2 d-flex justify-space-between align-center">
      <v-checkbox
        v-model="checkedAll"
        hide-details
        dense
        @change="handleCheckAll($event)"
      >
        <template v-slot:label>
          <span class="body-2">เลือกทั้งหมด</span>
        </template>
      </v-checkbox>
      <div>
        <span class="caption grey--text text--darken-2"
          >{{
            checkedAll ? totalEmployees : selectedEmployees.length
          }}
          รายการ</span
        >
      </div>
    </div>
    <div
      :style="`height: calc(100% - 230px); border: 1px solid #bdbdbd; ${
        checkedAll ? 'overflow-y: hidden' : 'overflow-y: auto'
      }`"
    >
      <DynamicScroller
        :items="employees"
        :min-item-size="pagination.limit"
        key-field="employee_uuid"
        class="px-2 py-2"
      >
        <template v-slot="{ item, index, active }">
          <DynamicScrollerItem
            :item="item"
            :active="active"
            :data-index="index"
          >
            <div>
              <div
                class="px-2 py-2 d-flex justify-space-between"
                v-observe-visibility="
                  item.employee_uuid === lastEmployee.employee_uuid &&
                  !isLastPage
                    ? infiniteScrollHandler
                    : false
                "
              >
                <div class="d-flex">
                  <v-checkbox
                    v-model="checkedEmployee[item.employee_uuid]"
                    @change="handleCheckEmployee($event, item)"
                    class="pt-0 mt-0"
                    hide-details
                    dense
                    :id="item.employee_uuid"
                    :value="checkedAll"
                    :disabled="checkedAll"
                  ></v-checkbox>
                  <label :for="item.employee_uuid" style="margin-top: 1px">
                    <div class="body-2">
                      {{ item.firstname_th }}
                      {{ item.lastname_th }} ({{ item.employee_code }})
                    </div>
                    <div class="body-2 grey--text">
                      หน่วยงาน:
                      {{ item.organization ? item.organization.title_th : '-' }}
                    </div>
                  </label>
                </div>
              </div>
              <v-divider></v-divider>
            </div>
          </DynamicScrollerItem>
        </template>
      </DynamicScroller>
      <div v-if="pagination.isLoading">
        <div class="px-2">
          <v-card
            color="#f5f5f5"
            v-for="num in 10"
            :key="num"
            outlined
            class="px-4 py-2 mb-2"
          >
            <Skeleton width="200px" />
            <Skeleton :count="1" />
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { Skeleton } from 'vue-loading-skeleton'
import { DynamicScroller, DynamicScrollerItem } from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { mapActions } from 'vuex'

export default {
  components: {
    DynamicScroller,
    DynamicScrollerItem,
    Skeleton,
  },
  props: {
    selectedEmployees: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      checkedAll: false,
      checkedEmployee: {},
      search: '',
      pagination: {
        currentPage: 1,
        limit: 10,
        isLoading: false,
      },
      employees: [],
      totalEmployees: 0,
    }
  },
  computed: {
    lastEmployee() {
      const [lastItem] = this.employees.slice(-1)
      return lastItem || {}
    },
    isLastPage() {
      return (
        this.pagination.currentPage ===
        Math.ceil(this.totalEmployees / this.pagination.limit)
      )
    },
  },
  created() {
    this.getEmployees()
  },
  methods: {
    ...mapActions({
      fetchEmployees: 'employee/fetchEmployees',
    }),
    handleCheckAll(value) {
      this.$emit('onCheckAllEmployee', value, this.checkedAll)
      // this.checkedEmployee = {}
    },
    handleCheckEmployee(value, employee) {
      this.$emit('onCheckEmployee', value, employee)
    },
    handleSearch: _.debounce(function () {
      if (this.search === undefined || this.search === null) return
      this.employees = []
      this.totalEmployees = 0
      this.pagination.currentPage = 1
      this.getEmployees()
    }, 1000),
    async getEmployees() {
      try {
        this.pagination.isLoading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'announcement-to-list-employee-no-filter',
            search: this.search || undefined,
            is_active: true,
            sort: 'employee_code:asc',
            limit: this.pagination.limit,
            offset: (this.pagination.currentPage - 1) * this.pagination.limit,
          },
        }

        await this.fetchEmployees(payload)

        const totalEmployees = this.$store.state.employee.totalEmployees
        const employees = this.$store.state.employee.employees

        this.totalEmployees = totalEmployees
        this.setEmployees(employees)

        this.pagination.isLoading = false
      } catch (error) {
        this.pagination.isLoading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    async getNextEmployees() {
      try {
        this.pagination.currentPage += 1

        await this.getEmployees()
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    setEmployees(employees) {
      this.employees = [...this.employees, ...employees]
    },
    infiniteScrollHandler(isVisible, entry) {
      if (isVisible && entry.isIntersecting) {
        this.getNextEmployees()
      }
    },
  },
}
</script>
